module.exports = __webpack_public_path__ + "static/media/Newman.06994b9e.png";